import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import { ISOCItemResponse } from "../../services/pet-detail/pet-detail.interface";
import { PetFormType } from "../../services/pet-create/pet-create.schema";

export const actionTypes = {
  SET_NEW_PET_IMAGE: "SET_NEW_PET_IMAGE",
  SET_NEW_PET_FORM: "SET_NEW_PET_FORM",
  SET_NEW_PET_TWO_FORM: "SET_NEW_PET_TWO_FORM",
  SET_PET_ID_SELECTED: "SET_PET_ID_SELECTED",
  SET_PET_INFO: "SET_PET_INFO",
  SET_SOC_SELECTED: "SET_SOC_SELECTED",
  SET_PET_LIST: "SET_PET_LIST",
  CLEAR_PET_INFO_MAP: "CLEAR_PET_INFO_MAP",
};

const setNewPetImage = (payload: File | null) => ({
  type: actionTypes.SET_NEW_PET_IMAGE,
  payload,
});

const setNewPetForm = (payload: PetFormType | null) => ({
  type: actionTypes.SET_NEW_PET_FORM,
  payload,
});

// const setNewPetTwoForm = (payload: PetTwoFormType | null) => ({
//   type: actionTypes.SET_NEW_PET_TWO_FORM,
//   payload,
// });

const setPetInfo = (payload: IPetItemResponse | null) => ({
  type: actionTypes.SET_PET_INFO,
  payload,
});

const setSOCSelect = (payload: ISOCItemResponse) => ({
  type: actionTypes.SET_SOC_SELECTED,
  payload,
});

const setPetList = (payload: IPetItemResponse[] | null) => ({
  type: actionTypes.SET_PET_LIST,
  payload,
});

const clearPetInfoMap = () => ({
  type: actionTypes.CLEAR_PET_INFO_MAP,
});

export default {
  setNewPetImage,
  setNewPetForm,
  setPetInfo,
  setSOCSelect,
  setPetList,
  clearPetInfoMap,
};
